import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

interface AuthRouteProps {
  children: React.ReactNode
}

/**
 * Route guard for auth pages (login).
 * Redirects authenticated users away from these pages.
 *
 * Redirect to "/" (RoleLanding), NOT "/dashboard": the advisor-only /dashboard would
 * bounce WRISE/admin to /access-denied. RoleLanding at "/" dispatches per role.
 */
export function AuthRoute({ children }: AuthRouteProps) {
  // Decided once on arrival: a sign-in on this page navigates itself (completeSignIn), a second redirect here would race it.
  const [alreadySignedIn] = useState(useAuthStore((state) => state.isAuthenticated))

  if (alreadySignedIn) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
